import { render, staticRenderFns } from "./AaaAaa004.vue?vue&type=template&id=21913123&scoped=true&"
import script from "./AaaAaa004.vue?vue&type=script&lang=js&"
export * from "./AaaAaa004.vue?vue&type=script&lang=js&"
import style0 from "./AaaAaa004.vue?vue&type=style&index=0&id=21913123&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21913123",
  null
  
)

export default component.exports